import { DecimalPipe } from '@angular/common';
import { Router } from '@angular/router';
import { ReusableFunctions } from '../classes/reusable-functions';

export class LGDonutChartOptions {
    constructor(
        private router: Router,
        private reusableFunctions: ReusableFunctions,
        private decimalPipe: DecimalPipe
    ) {}

    public getChartOptions(): Highcharts.Options {
        const _this = this;

        return {
            chart: {
                height: 290,
                type: 'pie',
                marginBottom: 96,
            },
            exporting: {
                enabled: false,
            },
            title: {
                text: null,
                align: 'left',
                x: 14,
                style: {
                    fontFamily: 'Roboto',
                    fontSize: '23px',
                    color: '#223540',
                },
            },
            series: [
                {
                    type: 'pie',
                    showInLegend: true,
                    data: null,
                } as Highcharts.SeriesPieOptions,
            ],
            subtitle: null,
            credits: {
                enabled: false,
            },
            tooltip: {
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    fontSize: '20',
                    height: 12,
                },
                borderColor: '#223540',
                borderRadius: 6,
                backgroundColor: '#FFFFFF',
                useHTML: true,
                shared: true,
                followPointer: true,
                distance: 15,
                formatter: function () {
                    return `<span style="color: ${
                        this.point.color
                    }; font-weight: bold; text-align: right; padding-right: 5px;">${
                        this.point.name
                    }</span> \
                    <span style="text-align: right;"><b>${_this.decimalPipe.transform(
                        this.point.percentage,
                        '1.1-1'
                    )}%</b></span><br> \
                    <span style="text-align: right;">${_this.reusableFunctions.formatMoney(
                        this.point.properties.volume
                    )}</span> \
                    <span style="padding: 0 5px 0 5px">/</span> \
                    <span style="text-align: right;">${this.point.properties.units}</span>`;
                },
            },
            plotOptions: {
                pie: {
                    point: {
                        events: {},
                    },
                    innerSize: '80%',
                    center: ['50%', '50%'],
                    size: 150,
                    dataLabels: {
                        enabled: false,
                        connectorShape: 'crookedLine',
                        alignTo: 'plotEdges',
                        crookDistance: 90,
                        format: '<span style="font-weight: normal; white-space: nowrap;">{point.name} {point.percentage:.1f} %</span>',
                    },
                },
            },
        };
    }
    public getChartOptionsForTwo(middleText, alternateValue: boolean): Highcharts.Options {
        const { title, description, type, textClickParams } = middleText;
        const _this = this;

        return {
            chart: {
                height: 290,
                type: 'pie',
                // marginBottom: 96,
                events: {
                    load: function () {
                        if (textClickParams && textClickParams.routerUrl) {
                            this.title.css({ cursor: 'pointer' });
                            this.title.on('click', function () {
                                _this.router.navigate([textClickParams.routerUrl], {
                                    queryParams: textClickParams.queryParams,
                                });
                            });
                        }
                    },
                },
            },
            exporting: {
                enabled: false,
            },
            title: {
                text: `<span style="font-weight: bold">${title}</span><br><span style="font-size: 15px;">${description}</span><br><span>${type}</span>`,
                verticalAlign: 'middle',
                style: {
                    fontFamily: 'Roboto',
                    fontSize: '22px',
                    color: '#223540',
                },
                y: 15,
            },
            series: [
                {
                    type: 'pie',
                    showInLegend: false,
                    data: null,
                } as Highcharts.SeriesPieOptions,
            ],
            subtitle: null,
            credits: {
                enabled: false,
            },
            tooltip: {
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    fontSize: '20',
                    height: 12,
                },
                borderColor: 'white',
                borderRadius: 6,
                backgroundColor: '#FFFFFF',
                useHTML: true,
                shared: true,
                followPointer: true,
                distance: 15,
                formatter: function () {
                    const mainValue = alternateValue
                        ? _this.reusableFunctions.getLargeCurrencyFormat(
                              this.point.properties.volume
                          )
                        : `${this.point.y} units`;
                    const percentage = alternateValue
                        ? `${this.point.properties.alternatePercentage.toFixed(2)}%`
                        : `${this.point.properties.percentage.toFixed(2)}%`;
                    const tooltipValue = `${mainValue} | ${percentage}`;
                    return `<div class="eclose-donut-container">
                        <div class="eclose-donut-tooltip-title">
                            <div class="eclose-donut-tooltip-name">${this.point.name}</div>
                        </div>
                        <div class="eclose-donut-tooltip-title eclose-donut-tooltip-value" style="border-bottom: none">
                            <div class="eclose-donut-tooltip-icon" style="color: ${this.point.color}">•</div>
                            <div style="font-size: 12px;">${tooltipValue}</div>
                        </div>
                    </div>`;
                },
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    point: {
                        events: {},
                    },
                    innerSize: '80%',
                    center: ['50%', '50%'],
                    size: 210,
                    dataLabels: {
                        enabled: false,
                        connectorShape: 'crookedLine',
                        alignTo: 'plotEdges',
                        crookDistance: 90,
                        format: '<span style="font-weight: normal; white-space: nowrap;">{point.name} {point.properties.alternatePercentage:.1f} %</span>',
                    },
                },
            },
        };
    }

    public getUpdatedChartOptions(): Highcharts.Options {
        const _this = this;

        return {
            chart: {
                height: 290,
                type: 'pie',
                marginBottom: 96,
            },
            exporting: {
                enabled: false,
            },
            title: {
                text: null,
                align: 'left',
                x: 14,
                style: {
                    fontFamily: 'Roboto',
                    fontSize: '23px',
                    color: '#223540',
                },
            },
            series: [
                {
                    type: 'pie',
                    showInLegend: false,
                    data: null,
                } as Highcharts.SeriesPieOptions,
            ],
            subtitle: null,
            credits: {
                enabled: false,
            },
            tooltip: {
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    fontSize: '20',
                    height: 12,
                },
                borderColor: 'white',
                borderRadius: 6,
                backgroundColor: '#FFFFFF',
                useHTML: true,
                shared: true,
                followPointer: true,
                distance: 15,
                formatter: function () {
                    const units = _this.reusableFunctions.formatNumber(this.point.properties.units);
                    const volume = _this.reusableFunctions.formatMoney(
                        this.point.properties.volume
                    );
                    const percentage = `${this.point.percentage.toFixed(1)}%`;
                    const tooltipValue1 = `${units} loans`;
                    const tooltipValue2 = `${volume}`;
                    return `<div class="donut-container">
                        <div class="donut-tooltip-title">
                            <div class="donut-tooltip-name">${this.point.name} - ${percentage}</div>
                        </div>
                        <div class="donut-tooltip-title donut-tooltip-value" style="border-bottom: none">
                            <div class="donut-tooltip-icon" style="color: ${this.point.color}">•</div>
                            <div style="font-size: 12px;"><span style='padding-right: 2px'>${tooltipValue1}</span> | <span style='padding-left: 2px'>${tooltipValue2}</span></div>
                        </div>
                    </div>`;
                },
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    point: {
                        events: {},
                    },
                    innerSize: '80%',
                    center: ['50%', '50%'],
                    size: 150,
                    dataLabels: {
                        enabled: false,
                        connectorShape: 'crookedLine',
                        alignTo: 'plotEdges',
                        crookDistance: 90,
                        format: '<span style="font-weight: normal; white-space: nowrap;">{point.name} {point.percentage:.1f} %</span>',
                    },
                },
            },
        };
    }

    public getChartOptionsWithLegend(middleText): Highcharts.Options {
        const { title, description, type } = middleText;
        const _this = this;

        return {
            chart: {
                height: 290,
                type: 'pie',
                marginBottom: 96,
            },
            exporting: {
                enabled: false,
            },
            title: {
                text: `<span style="font-weight: bold">${title}</span><br><span style="font-size: 15px;">${description}</span><br><span>${type}</span>`,
                verticalAlign: 'middle',
                style: {
                    fontFamily: 'Roboto',
                    fontSize: '22px',
                    color: '#223540',
                },
                y: -15,
            },
            series: [
                {
                    type: 'pie',
                    showInLegend: true,
                    data: null,
                } as Highcharts.SeriesPieOptions,
            ],
            subtitle: null,
            credits: {
                enabled: false,
            },
            tooltip: {
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    fontSize: '20',
                    height: 12,
                },
                borderColor: '#223540',
                borderRadius: 6,
                backgroundColor: '#FFFFFF',
                useHTML: true,
                shared: true,
                followPointer: true,
                distance: 15,
                formatter: function () {
                    return `<span style="color: ${
                        this.point.color
                    }; font-weight: bold; text-align: right; padding-right: 5px;">${
                        this.point.name
                    }</span> \
                    <span style="text-align: right;"><b>${_this.decimalPipe.transform(
                        this.point.percentage,
                        '1.1-1'
                    )}%</b></span><br> \
                    <span style="text-align: right;">${_this.reusableFunctions.formatMoney(
                        this.point.properties.volume
                    )}</span> \
                    <span style="padding: 0 5px 0 5px">/</span> \
                    <span style="text-align: right;">${this.point.properties.units} units</span>`;
                },
            },
            plotOptions: {
                pie: {
                    point: {
                        events: {},
                    },
                    innerSize: '80%',
                    center: ['50%', '50%'],
                    size: 150,
                    dataLabels: {
                        enabled: false,
                        connectorShape: 'crookedLine',
                        alignTo: 'plotEdges',
                        crookDistance: 90,
                        format: '<span style="font-weight: normal; white-space: nowrap;">{point.name} {point.percentage:.1f} %</span>',
                    },
                },
            },
        };
    }
}
